import React, { useMemo } from 'react';
import { useGetCalculationCategoryPairingsQuery } from '../../../screens/Calculations/apiCalculationsCategories';
import { SkuRedistributionPaneType } from '../../../screens/CalculationDetail/Redistribution/redistributionTypes';
import LinkIcon from '../Link/LinkIcon';
import { generatePath } from 'react-router';
import { ROUTES } from '../../menu/getMenuLeftItems';
import { useStableParams } from '../../../routes/useStableParams';
import { ROOT_CATEGORY_ID } from '../_constants';
import { createDefaultSkuPairingRequest } from '../../../screens/CalculationDetail/apiCalculationDetailLib';

interface SkuOpenRendererProps {
  sourceOrTarget: SkuRedistributionPaneType;
  calculationId: number;
  skuId: number;
}

const SkuOpenRenderer: React.FC<SkuOpenRendererProps> = ({
  sourceOrTarget,
  calculationId,
  skuId,
}) => {
  const { projectShortName } = useStableParams();

  const params = useMemo(
    () => createDefaultSkuPairingRequest(calculationId, sourceOrTarget, skuId),
    [calculationId, sourceOrTarget, skuId],
  );

  const { data: redistributionData } = useGetCalculationCategoryPairingsQuery(params);

  const firstRow = useMemo(
    () => (redistributionData?.data ?? []).find(d => d.quantity > 0),
    [redistributionData?.data],
  );

  const calculationDetailPath = generatePath(ROUTES.calculationDetail, {
    projectShortName: projectShortName ?? '',
    calculationId: `${calculationId}`,
    subpage: 'redistribution',
    slug: `${ROOT_CATEGORY_ID}`,
  });

  return (
    <LinkIcon
      url={`${calculationDetailPath}${firstRow ? `?p=${firstRow.sourceSku.skuId}-${firstRow.targetSku.skuId}` : ''}`}
    />
  );
};

export default SkuOpenRenderer;
